import { NgModule, LOCALE_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { rootRouterConfig } from './app.routes';
import { AppComponent } from './app.component';
import { FormsModule, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule, Http } from '@angular/http';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';

import { PainelComponent } from './painel/painel.component';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';

import { HeaderComponent } from './painel/header.component';
import { AsideComponent } from './painel/aside.component';
import { PageHeaderComponent } from './painel/page-header.component';
import { PageFooterComponent } from './painel/page-footer.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { UsuariosFormComponent } from './usuarios/usuarios-form.component';
import { UsuariosService } from './usuarios/usuarios.service';
import { BreadcrumbsComponent } from './shared/components/breadcrumbs.component';
import { LoginService } from './login/login.service';
import { LoginGuard } from './login/login-guard.service';
import { Global } from './global';
import { UsuariosCargosComponent } from './usuarios-cargos/usuarios-cargos.component';
import { UsuariosCargosFormComponent } from './usuarios-cargos/usuarios-cargos-form.component';
import { UsuariosCargosService } from './usuarios-cargos/usuarios-cargos.service';
import { PortosFormComponent } from './portos/portos-form.component';
import { PortosComponent } from './portos/portos.component';
import { PortosService } from './portos/portos.service';
import { NaviosService } from './navios/navios.service';
import { NaviosFormComponent } from './navios/navios-form.component';
import { NaviosComponent } from './navios/navios.component';
import { MoedasService } from './moedas/moedas.service';
import { MoedasFormComponent } from './moedas/moedas-form.component';
import { MoedasComponent } from './moedas/moedas.component';
import { ExamesNaviosService } from './exames/navios/exames-navios.service';
import { ExamesNaviosFormComponent } from './exames/navios/exames-navios-form.component';
import { ExamesNaviosComponent } from './exames/navios/exames-navios.component';
import { ExamesCargosService } from './exames/cargos/exames-cargos.service';
import { ExamesCargosFormComponent } from './exames/cargos/exames-cargos-form.component';
import { ExamesCargosComponent } from './exames/cargos/exames-cargos.component';
import { ExamesDispositivosService } from './exames/dispositivos/exames-dispositivos.service';
import { ExamesDispositivosFormComponent } from './exames/dispositivos/exames-dispositivos-form.component';
import { ExamesDispositivosComponent } from './exames/dispositivos/exames-dispositivos.component';
import { ExamesTesteSoproService } from './exames/teste-sopro/exames-teste-sopro.service';
import { ExamesTesteSoproFormComponent } from './exames/teste-sopro/exames-teste-sopro-form.component';
import { ExamesTesteSoproComponent } from './exames/teste-sopro/exames-teste-sopro.component';
import { PdfExamesTesteSoproComponent } from './exames/teste-sopro/pdf-exames-teste-sopro.component';
import { PdfAvisoTesteEtilometroComponent } from './exames/teste-sopro/pdf-aviso-teste-etilometro.component';
import { MeusTestesSoproComponent } from './area-cliente/meus-testes-sopro/meus-testes-sopro.component';
import { PdfMeusTestesSoproComponent } from './area-cliente/meus-testes-sopro/pdf-meus-testes-sopro.component';
import { ClientesTestesSoproService } from './area-cliente/meus-testes-sopro/clientes-testes-sopro.service';
import { MercadoriasFormComponent } from './mercadorias/mercadorias-form.component';
import { MercadoriasComponent } from './mercadorias/mercadorias.component';
import { MercadoriasService } from './mercadorias/mercadorias.service';
import { ContainersService } from './containers/containers.service';
import { ContainersFormComponent } from './containers/containers-form.component';
import { ContainersComponent } from './containers/containers.component';
import { Ng2PaginationModule } from 'ng2-pagination';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Funcoes } from './funcoes';
import { KeysBackPipe } from './shared/pipes/keys-back.pipe';
import { TemaUrlPipe } from './shared/pipes/tema-url.pipe';
import { PaisesComponent } from './paises/paises.component';
import { PaisesFormComponent } from './paises/paises-form.component';
import { PaisesService } from './paises/paises.service';
import { NaviosViagensTableComponent } from './navios-viagens/navios-viagens-table.component';
import { NaviosViagensService } from './navios-viagens/navios-viagens.service';
import { NaviosViagensFormComponent } from './navios-viagens/navios-viagens-form.component';
import { NaviosViagensComponent } from './navios-viagens/navios-viagens.component';
import { WidgetInputComponent } from './shared/form/widget-input.component';
import { WidgetInputColorComponent } from './shared/form/widget-input-color.component';
import { WidgetSelectComponent } from './shared/form/widget-select.component';
import { WidgetBooleanComponent } from './shared/form/widget-boolean.component';
import { WidgetInputCalendarioComponent } from './shared/form/widget-input-calendario.component';
import { WidgetFileUpload } from './shared/form/widget-file-upload';
import { FileUploadModule } from 'ng2-file-upload';
import { PdfViewerComponent } from './shared/components/pdf-viewer.component';
import { SafePipe } from './shared/pipes/safe.pipe';
import { DataHoraPipe } from './shared/pipes/data-hora.pipe';
import { MoedaPipe } from './shared/pipes/moeda.pipe';
import { UppercaseBKPDirective } from './shared/directives/uppercase_bkp.directive';
import { WidgetAvatarComponent } from './shared/form/widget-avatar.component';
import { WidgetInputMoedaComponent } from 'app/shared/form/widget-input-moeda.component';
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { UsuariosCargosPrivilegiosComponent } from "./usuarios-cargos/usuarios-cargos-privilegios.component";
import { MercadoriasDefeitosService } from "./mercadorias-defeitos/mercadorias-defeitos.service";
import { MercadoriasDefeitosComponent } from "./mercadorias-defeitos/mercadorias-defeitos.component";
import { MercadoriasDefeitosFormComponent } from "./mercadorias-defeitos/mercadorias-defeitos-form.component";
import { WidgetTextareaComponent } from "./shared/form/widget-text.component";
import { MercadoriasVariedadesComponent } from "./mercadorias-variedades/mercadorias-variedades.component";
import { MercadoriasVariedadesFormComponent } from "./mercadorias-variedades/mercadorias-variedades-form.component";
import { MercadoriasVariedadesService } from "./mercadorias-variedades/mercadorias-variedades.service";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { ClientesComponent } from "./clientes/clientes.component";
import { ClientesFormComponent } from "./clientes/clientes-form.component";
import { ClientesService } from "./clientes/clientes.service";
import { TipoTextoDirective } from "app/shared/directives/tipotexto.directive";
import { TiposClientesService } from "./clientes/tipos-clientes.service";
import { MercadoriasEmbalagensFormComponent } from "./mercadorias-embalagens/mercadorias-embalagens-form.component";
import { MercadoriasEmbalagensComponent } from "./mercadorias-embalagens/mercadorias-embalagens.component";
import { MercadoriasEmbalagensService } from "./mercadorias-embalagens/mercadorias-embalagens.service";
import { MercadoriasCategoriasFormComponent } from "./mercadorias-categorias/mercadorias-categorias-form.component";
import { MercadoriasCategoriasComponent } from "./mercadorias-categorias/mercadorias-categorias.component";
import { MercadoriasCategoriasService } from "./mercadorias-categorias/mercadorias-categorias.service";
import { MercadoriasColoracaoService } from "./mercadorias-coloracao/mercadorias-coloracao.service";
import { MercadoriasColoracaoComponent } from "./mercadorias-coloracao/mercadorias-coloracao.component";
import { MercadoriasColoracaoFormComponent } from "./mercadorias-coloracao/mercadorias-coloracao-form.component";
import { UnidadesService } from "./unidades/unidades.service";
import { UnidadesComponent } from "./unidades/unidades.component";
import { UnidadesFormComponent } from "./unidades/unidades-form.component";
import { TransportesService } from "./transportes/transportes.service";
import { TransportesComponent } from "./transportes/transportes.component";
import { TransportesFormComponent } from "./transportes/transportes-form.component";
import { LocaisComponent } from "./locais/locais.component";
import { LocaisFormComponent } from "./locais/locais-form.component";
import { LocaisService } from "./locais/locais.service";
import { TransportesViagensComponent } from "./transportes-viagens/transportes-viagens.component";
import { TransportesViagensFormComponent } from "./transportes-viagens/transportes-viagens-form.component";
import { TransportesViagensService } from "./transportes-viagens/transportes-viagens.service";
import { TransportesViagensTableComponent } from "./transportes-viagens/transportes-viagens-table.component";
import { ObservacoesFichasFormComponent } from "./observacoes-fichas/observacoes-fichas-form.component";
import { ObservacoesFichasComponent } from "./observacoes-fichas/observacoes-fichas.component";
import { ObservacoesFichasService } from "./observacoes-fichas/observacoes-fichas.service";
import { ConclusoesFichasService } from "./conclusoes-fichas/conclusoes-fichas.service";
import { ConclusoesFichasComponent } from "./conclusoes-fichas/conclusoes-fichas.component";
import { ConclusoesFichasFormComponent } from "./conclusoes-fichas/conclusoes-fichas-form.component";
import { FichasComponent } from "./fichas/fichas.component";
import { FichasFormComponent } from "./fichas/fichas-form.component";
import { FichasService } from "./fichas/fichas.service";
import { TextMaskModule } from "angular2-text-mask";
import { WidgetRadioComponent } from "./shared/form/widget-radio.component";
import { DndModule } from "ng2-dnd";
import { VisualizarFichaComponent } from "./fichas/visualizar-ficha.component";
import { FollowUpComponent } from "./follow-up/follow-up.component";
import { FollowUpFormComponent } from "./follow-up/follow-up-form.component";
import { FollowUpService } from "./follow-up/follow-up.service";
import { VeiculosComponent } from "./veiculos/veiculos.component";
import { VeiculosFormComponent } from "./veiculos/veiculos-form.component";
import { VeiculosService } from "./veiculos/veiculos.service";
import { EquipamentosModel } from "./equipamentos/equipamentos.model";
import { EquipamentosComponent } from "./equipamentos/equipamentos.component";
import { EquipamentosFormComponent } from "./equipamentos/equipamentos-form.component";
import { EquipamentosService } from "./equipamentos/equipamentos.service";
import { VeiculosCorridaService } from "./veiculos-corrida/veiculos-corrida.service";
import { VeiculosCorridaComponent } from "./veiculos-corrida/veiculos-corrida.component";
import { VeiculosCorridaFormComponent } from "./veiculos-corrida/veiculos-corrida-form.component";
import { VeiculosArquivosComponent } from "./veiculos/veiculos-arquivos.component";
import { ClientesUsuariosComponent } from "./clientes-usuarios/clientes-usuarios.component";
import { ClientesUsuariosFormComponent } from "./clientes-usuarios/clientes-usuarios-form.component";
import { ClientesUsuariosService } from "./clientes-usuarios/clientes-usuarios.service";
import { LoginClienteService } from "./login/login-cliente.service";
import { MinhasFichasComponent } from "./area-cliente/minhas-fichas/minhas-fichas.component";
import { ClientesFichasService } from "./area-cliente/clientes-fichas.service";
import { FichaClienteComponent } from "app/area-cliente/minhas-fichas/ficha-cliente.component";
import { PdfFichaClienteComponent } from "./area-cliente/minhas-fichas/pdf-ficha-cliente.component";
import { AdmClientesUsuariosService } from "./clientes-usuarios/adm-clientes-usuarios.service";
import { TabelaIndicesClassificacaoComponent } from "./mercadorias/tabela-indices-classificacao.component";
import { PdfFichaComponent } from "./fichas/pdf-ficha.component";
import { FinanceiroComponent } from "./financeiro/financeiro.component";
import { ControleFinanceiroComponent } from "./financeiro/controle-financeiro.component";
import { RelatorioCompletoComponent } from "./financeiro/relatorio-completo.component";
import { DashboardFinanceiroComponent } from "./financeiro/dashboard-financeiro.component";
import { FaturasComponent } from "./faturas/faturas.component";
import { VisualizarFaturaComponent } from "./faturas/visualizar-fatura.component";
import { FaturasService } from "./faturas/faturas.service";
import { FinanceiroClientesComponent } from "./financeiro/financeiro-clientes.component";
import { FinanceiroPreliminaresClienteComponent } from "./financeiro/financeiro-preliminares-cliente.component";
import { FinanceiroLaudosPdfClienteComponent } from "./financeiro/financeiro-laudos-pdf-cliente.component";
import { FinanceiroLaudosCdClienteComponent } from "./financeiro/financeiro-laudos-cd-cliente.component";
import { UnidadesMedidasComponent } from 'app/unidades-medidas/unidades-medidas.component';
import { UnidadesMedidasFormComponent } from "./unidades-medidas/unidades-medidas-form.component";
import { UnidadesMedidasService } from "./unidades-medidas/unidades-medidas.service";
import { BancosService } from "./bancos/bancos.service";
import { BancosComponent } from "./bancos/bancos.component";
import { BancosFormComponent } from "./bancos/bancos-form.component";
import { PdfFaturaComponent } from "./faturas/pdf-fatura.component";
import { ProtestosFichasComponent } from "./protestos-fichas/protestos-fichas.component";
import { ProtestosFichasFormComponent } from "./protestos-fichas/protestos-fichas-form.component";
import { ProtestosFichasService } from "./protestos-fichas/protestos-fichas.service";
import { LaudosPdfFormComponent } from "./laudos-pdf/laudos-pdf-form.component";
import { LaudosPdfComponent } from "./laudos-pdf/laudos-pdf.component";
import { LaudosPdfService } from "./laudos-pdf/laudos-pdf.service";
import { LaudosPdfFinanceiroComponent } from "./laudos-pdf/laudos-pdf-financeiro.component";
import { MeusLaudosPdfComponent } from "./area-cliente/meus-laudos-pdf/meus-laudos-pdf.component";
import { MeusLaudosPdfFormComponent } from "./area-cliente/meus-laudos-pdf/meus-laudos-pdf-form.component";
import { ClientesLaudosPdfService } from "./area-cliente/meus-laudos-pdf/clientes-laudos-pdf.service";
import { MeusLaudosCDComponent } from "./area-cliente/meus-laudos-cd/meus-laudos-cd.component";
import { MeusLaudosCDFormComponent } from "./area-cliente/meus-laudos-cd/meus-laudos-cd-form.component";
import { ClientesLaudosCDService } from "./area-cliente/meus-laudos-cd/clientes-laudos-cd.service";
import { FaturasFormComponent } from "./faturas/faturas-form.component";
import { MercadoriasClassificacaoComponent } from "./mercadorias-classificacao/mercadorias-classificacao.component";
import { MercadoriasClassificacaoService } from "./mercadorias-classificacao/mercadorias-classificacao.service";
import { MercadoriasClassificacaoFormComponent } from "./mercadorias-classificacao/mercadorias-classificacao-form.component";
import { TransportadorasService } from "./transportadoras/transportadoras.service";
import { TransportadorasComponent } from "./transportadoras/transportadoras.component";
import { TransportadorasFormComponent } from "./transportadoras/transportadoras-form.component";

import { ExportadoresService } from "./exportadores/exportadores.service";
import { ExportadoresComponent } from "./exportadores/exportadores.component";
import { ExportadoresFormComponent } from "./exportadores/exportadores-form.component";

import { TerminaisService } from "./terminais/terminais.service";
import { TerminaisComponent } from "./terminais/terminais.component";
import { TerminaisFormComponent } from "./terminais/terminais-form.component";

import { ArmadoresService } from "./armadores/armadores.service";
import { ArmadoresComponent } from "./armadores/armadores.component";
import { ArmadoresFormComponent } from "./armadores/armadores-form.component";

import { ColoracaoService } from "./laudos-cd-coloracao/coloracao.service";
import { ColoracaoComponent } from "./laudos-cd-coloracao/coloracao.component";
import { ColoracaoFormComponent } from "./laudos-cd-coloracao/coloracao-form.component";
import { LaudosCDComponent } from "./laudos-cd/laudos-cd.component";
import { TipoTransporteService } from "./laudos-cd/tipo-transporte.service";
import { TipoTransporteComponent } from "./tipo-transporte/tipo-transporte.component";
import { TipoTransporteFormComponent } from "./tipo-transporte/tipo-transporte-form.component";
import { TipoUnidadeService } from "./laudos-cd/tipo-unidade.service";
import { TipoUnidadeComponent } from "./tipo-unidade/tipo-unidade.component";
import { TipoUnidadeFormComponent } from "./tipo-unidade/tipo-unidade-form.component";
import { LabelFotosLaudoscdService } from "./laudos-cd/label-fotos-laudoscd.service";
import { LabelFotosLaudoscdComponent } from "./label-fotos-laudoscd/label-fotos-laudoscd.component";
import { LabelFotosLaudoscdFormComponent } from "./label-fotos-laudoscd/label-fotos-laudoscd-form.component";
import { UsuariosCargosNomesService } from "./usuarios-cargos-nomes/usuarios-cargos-nomes.service";
import { UsuariosCargosNomesComponent } from "./usuarios-cargos-nomes/usuarios-cargos-nomes.component";
import { UsuariosCargosNomesFormComponent } from "./usuarios-cargos-nomes/usuarios-cargos-nomes-form.component";
import { LaudosCDFormComponent } from "./laudos-cd/laudos-cd-form.component";
import { LaudosCDService } from "./laudos-cd/laudos-cd.service";
import { StakeholdersComponent } from "./laudos-cd-stakeholders/stakeholders.component";
import { StakeholdersFormComponent } from "./laudos-cd-stakeholders/stakeholders-form.component";
import { StakeholdersService } from "./laudos-cd-stakeholders/stakeholders.service";
import { ResponsaveisTecnicosComponent } from "./laudos-cd-responsaveis-tecnicos/responsaveis-tecnicos.component";
import { ResponsaveisTecnicosFormComponent } from "./laudos-cd-responsaveis-tecnicos/responsaveis-tecnicos-form.component";
import { ResponsaveisTecnicosService } from "./laudos-cd-responsaveis-tecnicos/responsaveis-tecnicos.service";
import { ObservacoesLaudosComponent } from "./laudos-cd-observacoes/observacoes-laudos.component";
import { ObservacoesLaudosFormComponent } from "./laudos-cd-observacoes/observacoes-laudos-form.component";
import { ObservacoesLaudosService } from "./laudos-cd-observacoes/observacoes-laudos.service";
import { ObservacoesFixasComponent } from "./laudos-cd-observacoes-fixas/observacoes-fixas.component";
import { ObservacoesFixasFormComponent } from "./laudos-cd-observacoes-fixas/observacoes-fixas-form.component";
import { ObservacoesFixasService } from "./laudos-cd-observacoes-fixas/observacoes-fixas.service";
import { FichasObservacoesFixasComponent } from "./fichas-observacoes-fixas/observacoes-fixas.component";
import { FichasObservacoesFixasFormComponent } from "./fichas-observacoes-fixas/observacoes-fixas-form.component";
import { FichasObservacoesFixasService } from "./fichas-observacoes-fixas/observacoes-fixas.service";
import { PdfLaudoCDComponent } from "./laudos-cd/pdf-laudo-cd.component";
import { LaudosCDFinanceiroComponent } from "./laudos-cd/laudos-cd-financeiro.component";

import { FinanceiroLaudosTecnicosClienteComponent } from "./financeiro/financeiro-laudos-tecnicos-cliente.component";
import { FinanceiroCertificadosNacionaisClienteComponent } from "./financeiro/financeiro-certificados-nacionais-cliente.component";
import { LaudosTecnicosFinanceiroComponent } from "./laudos-tecnicos/laudos-tecnicos-financeiro.component";
import { MeusLaudosTecnicosComponent } from "./area-cliente/meus-laudos-tecnicos/meus-laudos-tecnicos.component";
import { MeusLaudosTecnicosFormComponent } from "./area-cliente/meus-laudos-tecnicos/meus-laudos-tecnicos-form.component";
import { ClientesLaudosTecnicosService } from "./area-cliente/meus-laudos-tecnicos/clientes-laudos-tecnicos.service";

import { LaudosTecnicosComponent } from "./laudos-tecnicos/laudos-tecnicos.component";
import { LaudosTecnicosFormComponent } from "./laudos-tecnicos/laudos-tecnicos-form.component";
import { LaudosTecnicosService } from "./laudos-tecnicos/laudos-tecnicos.service";
import { LabelFotosLaudosTecnicosComponent } from "./label-fotos-laudostecnicos/label-fotos-laudostecnicos.component";
import { LabelFotosLaudosTecnicosFormComponent } from "./label-fotos-laudostecnicos/label-fotos-laudostecnicos-form.component";
import { LabelFotosLaudosTecnicosService } from "./laudos-tecnicos/label-fotos-laudostecnicos.service";

import { StakeholdersTecnicosComponent } from "./laudos-tecnicos-stakeholders/stakeholders.component";
import { StakeholdersTecnicosFormComponent } from "./laudos-tecnicos-stakeholders/stakeholders-form.component";
import { StakeholdersTecnicosService } from "./laudos-tecnicos-stakeholders/stakeholders.service";


import { PdfLaudoTecnicoComponent } from "./laudos-tecnicos/pdf-laudo-tecnico.component";

import { CertificadosNacionaisComponent } from './certificados-nacionais/certificados-nacionais.component';
import { CertificadosNacionaisFormComponent } from './certificados-nacionais/certificados-nacionais-form.component';
import { PdfCertificadoNacionalComponent } from './certificados-nacionais/pdf-certificado-nacional.component';
import { RelatorioCertificadosNacionaisComponent } from './certificados-nacionais/relatorio-certificados-nacionais.component';
import { RelatorioRmcvCertificadosNacionaisComponent } from './certificados-nacionais/relatorio-rmcv-certificados-nacionais.component';
import { CertificadosNacionaisService } from './certificados-nacionais/certificados-nacionais.service';
import { TerminaisNacionaisComponent } from './terminais-nacionais/terminais-nacionais.component';
import { TerminaisNacionaisFormComponent } from './terminais-nacionais/terminais-nacionais-form.component';
import { TerminaisNacionaisService } from './terminais-nacionais/terminais-nacionais.service';
import { AssinantesService } from './assinantes/assinantes.service';
import { AssinantesComponent } from './assinantes/assinantes.component';
import { AssinantesFormComponent } from './assinantes/assinantes-form.component';
import { ConfiguracoesComponent } from './configuracoes/configuracoes.component';
import { ConfiguracoesService } from './configuracoes/configuracoes.service';
import { LaboratoriosService } from './laboratorios/laboratorios.service';
import { LaboratoriosComponent } from './laboratorios/laboratorios.component';
import { LaboratoriosFormComponent } from './laboratorios/laboratorios-form.component';
import { LaboratoriosEmissoresComponent } from './laboratorios/laboratorios-emissores.component';
import { LaboratoriosEmissoresService } from './laboratorios/laboratorios-emissores.service';
import { CertificadosObservacoesService } from './certificados_observacoes/certificados-observacoes.service';
import { CertificadosObservacoesComponent } from './certificados_observacoes/certificados-observacoes.component';
import { CertificadosObservacoesFormComponent } from './certificados_observacoes/certificados-observacoes-form.component';
import { MercadoInternoMercadoriasService } from './mercado-interno-mercadorias/mercado-interno-mercadorias.service';
import { MercadoInternoVariedadesService } from './mercado-interno-mercadorias/mercado-interno-variedades.service';
import { MercadoInternoDefeitosService } from './mercado-interno-mercadorias/mercado-interno-defeitos.service';
import { MercadoInternoClassificacaoService } from './mercado-interno-mercadorias/mercado-interno-classificacao.service';
import { MercadoInternoMercadoriasComponent } from './mercado-interno-mercadorias/mercado-interno-mercadorias.component';
import { MercadoInternoMercadoriasFormComponent } from './mercado-interno-mercadorias/mercado-interno-mercadorias-form.component';
import { MercadoInternoVariedadesComponent } from './mercado-interno-mercadorias/mercado-interno-variedades.component';
import { MercadoInternoVariedadesFormComponent } from './mercado-interno-mercadorias/mercado-interno-variedades-form.component';
import { MercadoInternoTabelaIndicesClassificacaoComponent } from './mercado-interno-mercadorias/mercado-interno-tabela-indices-classificacao.component';
import { MercadoInternoDefeitosComponent } from './mercado-interno-mercadorias/mercado-interno-defeitos.component';
import { MercadoInternoDefeitosFormComponent } from './mercado-interno-mercadorias/mercado-interno-defeitos-form.component';
import { MercadoInternoClassificacaoComponent } from './mercado-interno-mercadorias/mercado-interno-classificacao.component';
import { MercadoInternoClassificacaoFormComponent } from './mercado-interno-mercadorias/mercado-interno-classificacao-form.component';
import { ValidarComponent } from './validar/validar.component';
import { ValidarService } from './validar/validar.service';


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PainelComponent,
    HeaderComponent,
    AsideComponent,
    PageHeaderComponent,
    BreadcrumbsComponent,
    PageFooterComponent,
    DashboardComponent,
    UsuariosComponent,
    UsuariosFormComponent,
    UsuariosCargosFormComponent,
    UsuariosCargosComponent,
    UsuariosCargosPrivilegiosComponent,
    BancosComponent,
    BancosFormComponent,
    ClientesComponent,
    ClientesFormComponent,
    ClientesUsuariosComponent,
    ClientesUsuariosFormComponent,
    LaudosPdfComponent,
    LaudosPdfFormComponent,
    LaudosPdfFinanceiroComponent,
    PortosFormComponent,
    PortosComponent,
    NaviosFormComponent,
    NaviosComponent,
    MoedasFormComponent,
    MoedasComponent,
    ExamesNaviosFormComponent,
    ExamesNaviosComponent,
    ExamesCargosFormComponent,
    ExamesCargosComponent,
    ExamesDispositivosFormComponent,
    ExamesDispositivosComponent,
    ExamesTesteSoproFormComponent,
    ExamesTesteSoproComponent,
    PdfExamesTesteSoproComponent,
    PdfAvisoTesteEtilometroComponent,
    MeusTestesSoproComponent,
    PdfMeusTestesSoproComponent,
    MercadoriasFormComponent,
    MercadoriasComponent,
    TabelaIndicesClassificacaoComponent,
    MercadoriasDefeitosComponent,
    MercadoriasDefeitosFormComponent,
    MercadoriasVariedadesComponent,
    MercadoriasVariedadesFormComponent,
    MercadoriasClassificacaoComponent,
    MercadoriasClassificacaoFormComponent,
    MercadoriasEmbalagensComponent,
    MercadoriasEmbalagensFormComponent,
    MercadoriasCategoriasComponent,
    MercadoriasCategoriasFormComponent,
    MercadoriasColoracaoComponent,
    MercadoriasColoracaoFormComponent,
    ContainersFormComponent,
    ContainersComponent,
    PaisesFormComponent,
    PaisesComponent,
    NaviosViagensComponent,
    NaviosViagensTableComponent,
    NaviosViagensFormComponent,
    TransportesComponent,
    TransportesFormComponent,
    TransportesViagensComponent,
    TransportesViagensFormComponent,
    TransportesViagensTableComponent,
    ObservacoesFichasComponent,
    ObservacoesFichasFormComponent,
    ConclusoesFichasComponent,
    ConclusoesFichasFormComponent,
    ProtestosFichasComponent,
    ProtestosFichasFormComponent,
    EquipamentosComponent,
    EquipamentosFormComponent,
    FaturasComponent,
    FaturasFormComponent,
    PdfFaturaComponent,
    VisualizarFaturaComponent,
    FichasComponent,
    FichasFormComponent,
    FinanceiroComponent,
    ControleFinanceiroComponent,
    RelatorioCompletoComponent,
    DashboardFinanceiroComponent,
    FinanceiroClientesComponent,
    FinanceiroPreliminaresClienteComponent,
    FinanceiroLaudosPdfClienteComponent,
    FinanceiroLaudosCdClienteComponent,
    MinhasFichasComponent,
    FichaClienteComponent,
    MeusLaudosPdfComponent,
    MeusLaudosPdfFormComponent,
    MeusLaudosCDComponent,
    MeusLaudosCDFormComponent,
    PdfFichaClienteComponent,
    PdfFichaComponent,
    FollowUpComponent,
    FollowUpFormComponent,
    VeiculosComponent,
    VeiculosFormComponent,
    VeiculosCorridaComponent,
    VeiculosCorridaFormComponent,
    VeiculosArquivosComponent,
    VisualizarFichaComponent,
    LocaisComponent,
    LocaisFormComponent,
    UnidadesComponent,
    UnidadesFormComponent,
    UnidadesMedidasComponent,
    UnidadesMedidasFormComponent,
    TransportadorasComponent,
    TransportadorasFormComponent,
    ExportadoresComponent,
    ExportadoresFormComponent,
    TerminaisComponent,
    TerminaisFormComponent,
    ArmadoresComponent,
    ArmadoresFormComponent,
    ColoracaoComponent,
    ColoracaoFormComponent,
    LaudosCDComponent,
    TipoTransporteComponent,
    TipoTransporteFormComponent,
    TipoUnidadeComponent,
    TipoUnidadeFormComponent,
    LabelFotosLaudoscdComponent,
    LabelFotosLaudoscdFormComponent,
    UsuariosCargosNomesComponent,
    UsuariosCargosNomesFormComponent,
    LaudosCDFormComponent,
    StakeholdersComponent,
    StakeholdersFormComponent,
    ResponsaveisTecnicosComponent,
    ResponsaveisTecnicosFormComponent,
    ObservacoesLaudosComponent,
    ObservacoesLaudosFormComponent,
    ObservacoesFixasComponent,
    ObservacoesFixasFormComponent,
    FichasObservacoesFixasComponent,
    FichasObservacoesFixasFormComponent,
    PdfLaudoCDComponent,
    LaudosCDFinanceiroComponent,
    FinanceiroLaudosTecnicosClienteComponent,
    FinanceiroCertificadosNacionaisClienteComponent,
    LaudosTecnicosFinanceiroComponent,
    MeusLaudosTecnicosComponent,
    MeusLaudosTecnicosFormComponent,

    LaudosTecnicosComponent,
    LaudosTecnicosFormComponent,
    LabelFotosLaudosTecnicosComponent,
    LabelFotosLaudosTecnicosFormComponent,
    StakeholdersTecnicosComponent,
    StakeholdersTecnicosFormComponent,


    PdfLaudoTecnicoComponent,
    PdfViewerComponent,
    WidgetInputComponent,
    WidgetInputColorComponent,
    WidgetInputCalendarioComponent,
    WidgetSelectComponent,
    WidgetBooleanComponent,
    WidgetFileUpload,
    WidgetAvatarComponent,
    WidgetInputMoedaComponent,
    WidgetTextareaComponent,
    WidgetRadioComponent,
    KeysBackPipe,
    TemaUrlPipe,
    SafePipe,
    DataHoraPipe,
    MoedaPipe,
    UppercaseBKPDirective,
    TipoTextoDirective,
    CertificadosNacionaisComponent,
    CertificadosNacionaisFormComponent,
    PdfCertificadoNacionalComponent,
    RelatorioCertificadosNacionaisComponent,
    RelatorioRmcvCertificadosNacionaisComponent,
    TerminaisNacionaisComponent,
    TerminaisNacionaisFormComponent,
    AssinantesComponent,
    AssinantesFormComponent,
    CertificadosObservacoesComponent,
    CertificadosObservacoesFormComponent,
    LaboratoriosComponent,
    LaboratoriosFormComponent,
    LaboratoriosEmissoresComponent,
    MercadoInternoMercadoriasComponent,
    MercadoInternoMercadoriasFormComponent,
    MercadoInternoVariedadesComponent,
    MercadoInternoVariedadesFormComponent,
    MercadoInternoTabelaIndicesClassificacaoComponent,
    MercadoInternoDefeitosComponent,
    MercadoInternoDefeitosFormComponent,
    MercadoInternoClassificacaoComponent,
    MercadoInternoClassificacaoFormComponent,
    ValidarComponent,
    ConfiguracoesComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    FileUploadModule,
    HttpModule,
    HttpClientModule,
    RouterModule.forRoot(rootRouterConfig),
    Ng2PaginationModule,
    CurrencyMaskModule,
    TextMaskModule,
    DndModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR'
    },
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    },
    Global,
    Funcoes,
    LoginGuard,
    UsuariosService,
    BancosService,
    ClientesService,
    ClientesUsuariosService,
    AdmClientesUsuariosService,
    EquipamentosService,
    TiposClientesService,
    LoginService,
    LoginClienteService,
    UsuariosCargosService,
    PortosService,
    NaviosService,
    MoedasService,
    ExamesNaviosService,
    ExamesCargosService,
    ExamesDispositivosService,
    ExamesTesteSoproService,
    ClientesTestesSoproService,
    MercadoriasService,
    MercadoriasDefeitosService,
    MercadoriasVariedadesService,
    MercadoriasClassificacaoService,
    MercadoriasEmbalagensService,
    MercadoriasCategoriasService,
    MercadoriasColoracaoService,
    ObservacoesFichasService,
    ProtestosFichasService,
    FaturasService,
    FichasService,
    ClientesFichasService,
    ClientesLaudosPdfService,
    ClientesLaudosCDService,
    FollowUpService,
    LaudosPdfService,
    ConclusoesFichasService,
    TransportesService,
    TransportesViagensService,
    LocaisService,
    ContainersService,
    PaisesService,
    NaviosViagensService,
    UnidadesService,
    UnidadesMedidasService,
    VeiculosService,
    VeiculosCorridaService,
    TransportadorasService,
    ExportadoresService,
    TerminaisService,
    ArmadoresService,
    ColoracaoService,
    TipoTransporteService,
    TipoUnidadeService,
    LabelFotosLaudoscdService,
    UsuariosCargosNomesService,
    LaudosCDService,
    StakeholdersService,
    ResponsaveisTecnicosService,
    ObservacoesLaudosService,
    ObservacoesFixasService,
    FichasObservacoesFixasService,
    ClientesLaudosTecnicosService,
    LaudosTecnicosService,
    LabelFotosLaudosTecnicosService,
    StakeholdersTecnicosService,
    CertificadosNacionaisService,
    TerminaisNacionaisService,
    AssinantesService,
    LaboratoriosService,
    LaboratoriosEmissoresService,
    CertificadosObservacoesService,
    MercadoInternoMercadoriasService,
    MercadoInternoVariedadesService,
    MercadoInternoDefeitosService,
    MercadoInternoClassificacaoService,
    ValidarService,
    ConfiguracoesService,
    FormBuilder
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

}



// WEBPACK FOOTER //
// ./src/app/app.module.ts